import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page43() {
  useEffect(() => {
    document.title = "Маяк — Страница 42"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page41" />
        <ForwardLink href="/page43" />
      </div>

      <p style={{ textAlign: "right" }}>42.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК И МОЛОДОЙ<br/>
        (поют)<br/>
        Ура, мы возвращаемся домой,<br/>
        Ура, мы возвращаемся домой!
      </p>
      <br/>
      <p>-ГОСТИНАЯ. ПОЗЖЕ</p>
      <p>Они все еще пьют.</p>
      <p>СТАРИК курит сигарету. МОЛОДОЙ курит трубку СТАРИКА.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ...и хорошенькая девица была,<br/>
        сняла чепчик... а я,<br/>
        как говорится, ногу сломал и весь<br/>
        избился. Это было в монашеской<br/>
        больнице... Все они были<br/>
        католичками, я тебе говорю...
      </p>
      <p>Они смеются.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Да, но с тех пор я никогда не ездил в Салем<br/>
        без надежды<br/>
        увидеть ее, потому что секс с тех пор уже не был<br/>
        прежним. Не знаю, но если бы я собирался начать<br/>
        жизнь сначала... ну, женщины<br/>
        все равно ужасно стыдятся<br/>
        этого.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Чувствуете стыд, когда обманываете<br/>
        женщин?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Да ничего я не чувствую.
      </p>
      <p>Пауза. Они смеются.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Что ж, я скажу это... Я, возможно, даже<br/>
        буду скучать по тебе, Эфраим Уинслоу, ты<br/>
        быстро становишься настоящим синим викки.<br/>
        Я думал, однажды ночью ты расколешь мне череп<br/>
        пополам, но ты молодец. Поэтому<br/>
        ты скоро начнешь работать на фонаре –
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Почему не сейчас?
      </p>
      <p style={{ textAlign: "right" }}>42.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page41" />
        <ForwardLink href="/page43" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710314545/the-lighthouse-script/k92v2odz4u0wt8wklzq8.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page43;
